/**
 * Calculate Joined Days Utility
 * 
 * Calculates the number of days since a user joined
 */

export function calculateJoinedDaysAgo(joinedDate: string | Date): number {
  const joined = typeof joinedDate === 'string' ? new Date(joinedDate) : joinedDate;
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - joined.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}
